import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import type { LiveStreamSettings } from '@/lib/types';

export function useLiveStreamSettings() {
  const [data, setData] = useState<LiveStreamSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data: row, error: err } = await supabase
        .from('live_stream_settings')
        .select('*')
        .eq('id', 1)
        .single();
      if (err) throw err;
      setData(row as LiveStreamSettings);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { data, loading, error, reload };
}